/**
 * Media aggregates from /map-data (flag mediaAggregates).
 * Compact shape replaces full spotify/appleMusic/movies/shows arrays.
 */

export function isMediaAggregate(value) {
  return Boolean(value && typeof value === 'object' && !Array.isArray(value) && value._aggregate);
}

export function mediaTotal(value) {
  if (isMediaAggregate(value)) return Number(value.total) || 0;
  if (Array.isArray(value)) return value.length;
  return 0;
}

export function mediaByDay(value) {
  if (isMediaAggregate(value)) {
    return Array.isArray(value.byDay) ? value.byDay : [];
  }
  return null;
}

/** Synthetic day stubs for streak/correlation/calendar when payload is aggregate. */
export function expandAggregateDays(value, dateField = 'played_at') {
  const days = mediaByDay(value);
  if (!days) return Array.isArray(value) ? value : [];
  const stubs = [];
  days.forEach(({ date, count }) => {
    const n = Math.max(1, Number(count) || 1);
    for (let i = 0; i < n; i += 1) {
      stubs.push({ [dateField]: `${date}T12:00:00`, date });
    }
  });
  return stubs;
}

/** One stub per day (streaks only need presence). */
export function expandAggregateDayPresence(value, dateField = 'played_at') {
  const days = mediaByDay(value);
  if (!days) return Array.isArray(value) ? value : [];
  return days
    .filter((d) => d && d.date)
    .map(({ date }) => ({ [dateField]: `${date}T12:00:00`, date }));
}

export function mediaSourceNonempty(value) {
  return mediaTotal(value) > 0;
}
